import { isMobile } from '@growtherapy/analytics';

import { useTheme } from '../../hooks/useTheme';
import { Theme } from '../../state/theme';
import { isSafari as isBrowserSafari } from '../../utils';
import { BlockedPermissionMessage, WithPassThroughProps } from './BlockedPermissionMessage';

/**
 * When using this component, make sure any of the following hooks are executed
 * to be sure the application stays in-sync with the user's device permissions:
 * - useUpdateAvailableDevicesInterval
 * - useListenForAvailableDeviceChanges
 */
export function BlockedPermissionMessageWrapper(props: WithPassThroughProps) {
  const isMobileDevice = isMobile(navigator.userAgent);
  const isSafari = isBrowserSafari();
  const { theme } = useTheme();
  return (
    <BlockedPermissionMessage
      {...props}
      isMobile={isMobileDevice}
      isSafari={isSafari}
      isDarkTheme={theme === Theme.DARK}
    />
  );
}
